export default "__VITE_ASSET__21159eb9__"